module.exports = __webpack_public_path__ + "img/btn-cadillac@3x.e47eed85.png";